// getters
const inventoryProductsSubCategories = state => state.inventoryProductsSubCategories

export default {
  inventoryProductsSubCategories
}



// WEBPACK FOOTER //
// ./src/store/modules/inventory/products/subcategories/getters.js